import { ValidatorRuleType } from "@gaiaProfessionals/Common/Utilities/validate";

export const intialErrorFormState = {
    country: "",
    state: "",
    city: "",
    postalCode: "",
    address1: "",
    phoneNumber: "",
    practiceName: "",
    practiceType: "",
    partitionerCertificate: "",
    taxIdEin: "",
};

export const intialErrorFormStateNonDefault = {
    partitionerCertificate: "",
};

export const practiceTypeOptions = [
    {
        value: "DC",
        label: "DC",
    },
    {
        value: "DDS",
        label: "DDS",
    },
    {
        value: "DO",
        label: "DO",
    },
    {
        value: "DTR",
        label: "DTR",
    },
    {
        value: "Health/Wellness Coach",
        label: "Health/Wellness Coach",
    },
    {
        value: "Herbalist",
        label: "Herbalist",
    },
    {
        value: "Lac",
        label: "Lac",
    },
    {
        value: "LMT",
        label: "LMT",
    },
    {
        value: "MD",
        label: "MD",
    },
    {
        value: "Midwife",
        label: "Midwife",
    },
    {
        value: "ND",
        label: "ND",
    },
    {
        value: "NP",
        label: "NP",
    },
    {
        value: "Nutritionist",
        label: "Nutritionist",
    },
    {
        value: "OMD",
        label: "OMD",
    },
    {
        value: "PA",
        label: "PA",
    },
    {
        value: "RD",
        label: "RD",
    },
    {
        value: "RN",
        label: "RN",
    },
    {
        value: "RPH",
        label: "RPH",
    },
    {
        value: "Student",
        label: "Student",
    },
];

export const interestedInGaiaHerbs = [
    {
        value: "personal use only",
        label: "Personal use only",
    },
    {
        value: "patients/clients only",
        label: "Patients/Clients only",
    },
    {
        value: "both personal and patients/clients",
        label: "Both",
    },
];

export const recommendationsOptions = [
    {
        value: "Dont recommend herbs to patients/clients",
        label: "Don't recommend herbs to patients/clients",
    },
    {
        value: "We sell in our office",
        label: "We sell in our office",
    },
    {
        value: "We refer patients/clients to a retail store",
        label: "We refer patients/clients to a retail store",
    },
    {
        value: "We refer patients/clients to an online shop",
        label: "We refer patients/clients to an online shop",
    },
    {
        value: "We use a patient drop ship or online patient dispensary program",
        label: "We use a patient drop ship or online patient dispensary program",
    },
    {
        value: "Combination- sell in office and use online patient dispensary program",
        label: "Combination- sell in office and use online patient dispensary program",
    },
];

export const refererOptions = [
    {
        value: "gaiaherbs.com",
        label: "gaiaherbs.com",
    },
    {
        value: "Social media",
        label: "Social media",
    },
    {
        value: "Webinar",
        label: "Webinar",
    },
    {
        value: "Trade Show",
        label: "Trade Show",
    },
    {
        value: "Google/Web search",
        label: "Google/Web search",
    },
    {
        value: "Other",
        label: "Other",
    },
];

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const newCustomerValidatorConfig: ValidatorConfigType = {
    phoneNumber: {
        required: true,
        label: "Phone Number",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Phone Number",
    },
    practiceName: {
        required: true,
        label: "Practice Name",
    },
    practiceType: {
        required: true,
        label: "Practitioner Type",
    },
    partitionerCertificate: {
        required: true,
        label: "Certificate",
    },
    address1: {
        required: true,
        label: "Address line 1",
    },
    address2: {
        required: false,
        label: "Address line 2",
    },
    address3: {
        required: false,
        label: "Address line 3",
    },
    country: {
        required: true,
        label: "Country Name",
    },
    state: {
        required: true,
        label: "State Name",
    },
    city: {
        required: true,
        label: "City Name",
    },
    postalCode: {
        required: true,
        regex: /^[a-zA-Z0-9 ]*$/,
        label: "Postal Code",
    },
    shipAddress1: {
        required: true,
        label: "Address line 1",
    },
    shipAddress2: {
        required: false,
        label: "Address line 2",
    },
    shipAddress3: {
        required: false,
        label: "Address line 3",
    },
    shipCountry: {
        required: true,
        label: "Country Name",
    },
    shipState: {
        required: true,
        label: "State Name",
    },
    shipCity: {
        required: true,
        label: "City",
    },
    shipPostalCode: {
        required: true,
        regex: /^[a-zA-Z0-9 ]*$/,
        label: "Postal Code",
    },
    taxIdEin: {
        required: true,
        label: "Tax ID/EIN",
    },
};
